import React, { useState, useCallback } from 'react';

export default function LikeButton (props) {
  const [like, setLike] = useState(false);

  const handleClick = useCallback(() => {
    if(!like) setLike(true);

    props.onClick();
  }, [like, setLike]);

  return (<>
    {props.like_cnt && (<div className={`live_btn_like`}>
      <a
        className={`live_link_cont ${like ? 'current' : ''}`}
        title='좋아요'
        tabIndex='0'
        role='button'
        aria-label={`${like ? '나 포함하여 ' : '나 이외에 '} ${props.like_cnt}명 ${props.title} 을 좋아요 헀습니다. `}
        onClick={handleClick.bind(this)}
      >
        <span className='live_btn_icon'>
          <svg
            xmlns='http://www.w3.org/2000/svg'
            width='27.001'
            height='26'
            viewBox='0 0 27.001 26'
          >
            <path
              className='icon_like'
              d='M574.462,503.148a7.951,7.951,0,0,0-6.99-4.416h-.016a7.777,7.777,0,0,0-5.412,2.212,7.8,7.8,0,0,0-5.429-2.211H556.6a7.934,7.934,0,0,0-6.959,4.39c-2.265,4.234-.324,8.978-.216,9.234a27.473,27.473,0,0,0,12.124,12.266,1.422,1.422,0,0,0,.546.109.981.981,0,0,0,.454-.109A27.5,27.5,0,0,0,574.7,512.3C574.78,512.1,576.715,507.357,574.462,503.148Zm-1.59,8.322a25.449,25.449,0,0,1-10.828,11.158,25.435,25.435,0,0,1-10.8-11.1c-.017-.041-1.661-4.057.173-7.488a5.946,5.946,0,0,1,5.206-3.308h.01a5.759,5.759,0,0,1,4.564,2.279,1.25,1.25,0,0,0,.9.4,1,1,0,0,0,.787-.4,5.754,5.754,0,0,1,4.55-2.27h.011a5.962,5.962,0,0,1,5.236,3.334C574.488,507.441,572.872,511.47,572.872,511.47Z'
              transform='translate(-548.548 -498.732)'
            ></path>
            <path
              className='icon_like_active'
              d='M574.972,468.084a7.949,7.949,0,0,0-6.991-4.417h-.015a7.77,7.77,0,0,0-5.412,2.213,7.789,7.789,0,0,0-5.428-2.212h-.015a7.937,7.937,0,0,0-6.96,4.391c-2.265,4.234-.325,8.978-.216,9.234a27.475,27.475,0,0,0,12.125,12.266,1.436,1.436,0,0,0,.546.108,1,1,0,0,0,.452-.108,27.5,27.5,0,0,0,12.148-12.324C575.289,477.035,577.225,472.292,574.972,468.084Z'
              transform='translate(-549.058 -463.667)'
            ></path>
          </svg>
          <i className='hide'>좋아요</i>
        </span>
        <span className='live_count'>
          {props.like_cnt}
        </span>
      </a>
    </div>)}
  </>
  );
}
